'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = tabbable;

var _lodash = require('lodash');

/**
 *
 */
var SELECTOR = '\n\ta,\n\tbutton,\n\tinput,\n\tselect,\n\ttextarea,\n\tobject,\n\t[tabindex]\n';

/**
 *	Tells if the given link element is tabbable, i.e if it
 *	has an href attribute or a valid tab index.
 *
 *	@param DOMElement link Link.
 *	@return boolean If the link is tabbable.
 */
function isTabbableLink(link) {
	var hasHref = !!link.getAttribute('href');
	var tabIndex = parseInt(link.getAttribute('tabindex'), 10);
	var hasTabIndex = !isNaN(tabIndex);

	return hasHref ? !hasTabIndex || tabIndex >= 0 : hasTabIndex && tabIndex >= 0;
}

/**
 *	Tells if the given element is tabbable, i.e if it is not
 *	disabled and has a valid tab index.
 *
 *	@param DOMElement link Link.
 *	@return boolean If the link is tabbable.
 */
function isTabbableElement(element) {
	if (element.getAttribute('disabled')) {
		return false;
	}

	var tabIndex = element.getAttribute('tabindex');

	if (!tabIndex) {
		return true;
	}

	return tabIndex >= 0;
}

/**
 *
 */
function isLink(element) {
	return element.tagName === 'a' || element.tagName === 'A';
}

/**
 *
 */
function isTabbable(element) {
	return isLink(element) ? isTabbableLink(element) : isTabbableElement(element);
}

/**
 *	Returns all tabbable elements inside the given container.
 *
 *	@param DOMElement container Container.
 *	@return Array Tabbable elements.
 */
function tabbable() {
	var container = arguments.length <= 0 || arguments[0] === undefined ? document : arguments[0];

	var elements = container.querySelectorAll(SELECTOR);
	return (0, _lodash.filter)(elements, isTabbable);
}